import { render } from "./functional_information_wealthsById.vue?vue&type=template&id=4ba892a8&scoped=true"
import script from "./functional_information_wealthsById.vue?vue&type=script&lang=js"
export * from "./functional_information_wealthsById.vue?vue&type=script&lang=js"

import "./functional_information_wealthsById.vue?vue&type=style&index=0&id=4ba892a8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba892a8"]])

export default __exports__